import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-header-page',
  templateUrl: './sub-header-page.component.html',
  styleUrls: ['./sub-header-page.component.scss']
})
export class SubHeaderPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
